import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface LoginNoticeItem {
  noticeText: string;
  noticeStartDate: string | null;
}

export interface LoginMaintenanceStatus {
  isSuspended: boolean;
  suspendStartDate: string | null;
  suspendEndDate: string | null;
  notices: LoginNoticeItem[];
}

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {

  // APIM未登録エンドポイントのため、useApiGatewayフラグに関わらず常に directApiUrl（直接接続）を使用する
  private readonly baseUrl = environment.directApiUrl;

  constructor(private http: HttpClient) {}

  getLoginMaintenanceStatus(): Observable<LoginMaintenanceStatus> {
    return this.http.get<LoginMaintenanceStatus>(
      `${this.baseUrl}/SysManagement/maintenance/login-status`
    ).pipe(
      catchError(() => of({ isSuspended: false, suspendStartDate: null, suspendEndDate: null, notices: [] }))
    );
  }
}
